<template>
  <WdsStack align-center gap-sm>
    <WdsIcon :name="WdsIconNameEnum.LOCATION" :size="16" class="tw-flex-shrink-0" />

    <WdsText
      data-test="location-text"
      :text="locationText"
      :title="locationText"
      primary
      class="tw-line-clamp-1"
    />
  </WdsStack>

  <WdsStack align-center gap-sm>
    <WdsIcon :name="countryIcon" :size="16" class="tw-flex-shrink-0" />

    <WdsText
      data-test="country-text"
      :text="countryText"
      :title="countryText"
      primary
      class="tw-line-clamp-1"
    />
  </WdsStack>

  <WdsStack align-center gap-sm>
    <WdsIcon :name="marketIcon" :size="16" class="tw-flex-shrink-0" />

    <WdsText
      data-test="market-text"
      :text="currency"
      :title="currency"
      primary
      class="tw-line-clamp-1"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsIconNameEnum, WdsStack, WdsIcon, WdsText } from '@worksome/wds-components'
import { computed, ComputedRef } from 'vue'
import { Address, Market } from '@/gql/graphql'

const props = defineProps<{
  address: Address
  market: Market
  currency: string
}>()

const countryIcon: ComputedRef<WdsIconNameEnum> = computed(() => {
  if (!props.address?.country?.isoCode) {
    return WdsIconNameEnum.MAP
  }

  return WdsIconNameEnum[`FLAG_${props.address?.country?.isoCode}`]
})

const marketIcon: ComputedRef<WdsIconNameEnum> = computed(() => {
  if (!props.market?.code) {
    return WdsIconNameEnum.EARTH
  }

  return WdsIconNameEnum[`FLAG_${props?.market?.code}`]
})

const locationText = computed(() => {
  if (!props.address.state && !props.address.city) {
    return '-'
  }

  if (props.address.state && props.address.city) {
    return `${props.address.city}, ${props.address.state}`
  }

  return (props.address.city !== '' ? props.address.city : null) ?? `-, ${props.address.state}`
})

const countryText = computed(() => props.address.country?.name ?? '-')
</script>
